import { Box, IconButton, Typography } from "@mui/material";
import useTranslationSetup from "../../utils/useTranslationSetup";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import "./styles.css";

const AssessmentHeader = ({ showBackButton, heading, onClick }) => {
  const { activeLanguage } = useTranslationSetup();

  return (
    <Box className="assessment-header-container">
      <Box
        className={`back-icon-heading-wrapper ${showBackButton ? "show" : ""}`}
      >
        {showBackButton && (
          <Box className="assessment-header-back-button-wrapper">
            <IconButton onClick={onClick}>
              <ArrowBackRoundedIcon className="assessment-header-back-button-icon btn-primary" />
            </IconButton>
          </Box>
        )}
        <Typography
          className="custom-ff-regular assessment-header-heading"
          lang={activeLanguage}
        >
          {heading}
        </Typography>
        {showBackButton && (
          <Box className="assessment-header-back-button-wrapper"></Box>
        )}
      </Box>
    </Box>
  );
};

export default AssessmentHeader;
